export default "/static/images/4e6dfda4d4c084c7.png";